<template>
  <div
    :class="[
      usingNewLayout ? 'tw-w-full' : 'tw-w-[421px]',
      'tw-flex tw-flex-col',
    ]"
  >
    <header
      class="
        tw-h-[60px]
        tw-sticky
        tw-top-0
        tw-bg-sf-snow-lighter
        tw-z-10
        tw-flex
        tw-justify-between
        tw-items-center
        tw-px-4
        tw-py-3
        tw-border-0
        tw-border-b
        tw-border-sf-neutral-lighter-2
        tw-border-solid
      "
    >
      <div class="tw-font-medium tw-px-1">
        <span class="tw-text-base tw-mr-1">{{ copy.title }}</span>
        <SfIndicatorCount ai data-testid="suggested-talking-point-count">{{
          suggestionCount
        }}</SfIndicatorCount>
      </div>
      <SfButtonDs
        variant="secondary"
        class="tw-w-9 tw-h-9"
        data-testid="close-main-sidebar-button"
        @click="closeSidebar"
      >
        <i class="fa fa-arrow-right" />
      </SfButtonDs>
    </header>
    <div
      class="tw-p-4 tw-h-full tw-overflow-y-auto"
      data-testid="suggested-talking-points"
    >
      <div
        v-if="loadingSuggestions"
        class="
          tw-flex
          tw-items-center
          tw-gap-4
          tw-px-4
          tw-py-9
          tw-bg-sf-ai-subtle-1
          tw-text-sf-ai-darker-1
          tw-rounded-lg
          tw-mb-6
        "
      >
        <div
          class="
            sf-spinner sf-spinner-primary sf-spinner-l
            tw-border-sf-ai-light-2 tw-h-[30px] tw-w-[30px]
            tw-flex-[0_0_30px]
          "
        ></div>
        <div>
          {{ copy.loading }}
        </div>
      </div>
      <div v-else class="tw-flex tw-flex-col tw-gap-4">
        <SuggestedTalkingPoint
          v-for="suggestion in suggestions"
          :key="suggestion"
          :text="suggestion"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { storeToRefs } from 'pinia'

import useI18n from '@app/shared/vue/composables/use-I18n'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import { SfIndicatorCount } from '@app/shared/vue/components/sf-indicator'
import SuggestedTalkingPoint from '@app/application/client_meetings/screens/prepare/components/main-sidebar/suggested-talking-point.vue'

import { useSuggestedTalkingPointsStore } from '@app/application/client_meetings/screens/prepare/stores/suggested-talking-points'
import { useDrawer } from '@app/shared/pinia/drawer'
import { isUsingNewLayout } from '@app/adapters/silverfin'

import { setSafeJSONValue } from '@app/utils/local-storage'
import type { PreparePageData } from '@app/application/client_meetings/types'

const pageData = inject('pageData') as PreparePageData

const usingNewLayout = isUsingNewLayout()
const I18n = useI18n()
const copy = {
  title: I18n.t('client_meetings.prepare.sidebar.title'),
  loading: I18n.t('client_meetings.prepare.sidebar.loading'),
}

const suggestedTalkingPointsStore = useSuggestedTalkingPointsStore()

const drawerStore = useDrawer()

function closeSidebar() {
  setSafeJSONValue('showMeetingPreparationSidebar', false)
  drawerStore.closeRightDrawerWithoutPersisting(false)
}

const { suggestions, suggestionCount, loadingSuggestions } = storeToRefs(
  suggestedTalkingPointsStore
)

if (pageData.suggestions) {
  suggestedTalkingPointsStore.setSuggestions(pageData.suggestions)
} else {
  suggestedTalkingPointsStore.fetchSuggestions()
}
</script>
